import { Typography } from "../Typography";
import type { IMenuHeader as IMenuHeaderType } from "./types";
import { clsx } from "clsx";

type MenuHeaderProps = {
  item: IMenuHeaderType;
};

export const MenuHeader = ({ item }: MenuHeaderProps) => {
  return (
    <div className={clsx("nuco-menu__header", item.className)}>
      <Typography variant="body" weight="bold">
        {item.text}
      </Typography>
    </div>
  );
};
